<template>
    <generic :modeParams="modeParams" @tryItNowDialogOpen="$emit('tryItNowDialogOpen')" ></generic>
</template>

<script>
    import generic from './home/generic'
    //import Vue from 'vue'
    import i18n from '@/i18n';
    import Page from '../mixins/page'

    export default {
        name: 'Home',
        mixins: [Page],
        computed: {
            pageTitle() {
                return i18n.t('home.pageTitle');
            },
            pageDescription() {
                return i18n.t('home.pageDescription', {platformName: 'xCloud'});
            }
        },
        components: {generic},
        data: () => ({
            modeParams: {
                platformName: 'xCloud™',
                platformNameVariant2: 'xCloud™',
                supportedPlatforms: [
                    {title: 'Android', soon: false},
                    {title: 'XBox', soon: false},
                    {title: 'PC (Browser)', soon: false},
                    {title: 'IOS', soon: false},
                    {title: 'PC (App)', soon: true},
                ]
            }
        })
    };

</script>
